module.exports = __webpack_public_path__ + "img/SuperOK-Banner031121.68ee3cf2.jpg";